const publicUrl = process.env.PUBLIC_URL || "";
const asset = (path) => `${publicUrl}${path}`;

export const profile = {
  name: "Tran Viet Gia Huy",
  initials: "TH",
  nickname: "Tommy",
  role: "Data Analyst & Analytics Engineer",
  location: "Ho Chi Minh City, Vietnam",
  phone: "(+84) 905566227",
  email: "giahuytranviet.work@gmail.com",
  linkedin: "https://www.linkedin.com/in/giahuytranviet",
  github: "https://github.com/Tommyhuy1705",
  photo: asset("/profile-photo.jpg"),
  resume: asset("/TranVietGiaHuy_Resume.pdf"),
  tagline:
    "Turning complex business data into decision systems with SQL, Python, BI dashboards, and AI-assisted analytics.",
  rotating: [
    "Modeling business impact",
    "Optimizing SQL pipelines",
    "Building BI dashboards",
    "Designing analytics systems",
  ],
  stats: [
    { value: "3.75", label: "GPA / 4.0" },
    { value: "250+", label: "Teams Outperformed" },
    { value: "9+", label: "Case Studies" },
    { value: "4x", label: "UEH Scholarships" },
  ],
  about: [
    [
      { text: "I am a " },
      { text: "Computer Science student", strong: true },
      { text: " and product-oriented builder on the path to becoming a " },
      { text: "Full-Stack Data Professional", strong: true },
      {
        text:
          " across analytics, engineering, BI, and applied AI. My work focuses on turning complex business and financial problems into reliable data models, dashboards, forecasts, and practical recommendations.",
      },
    ],
    [
      { text: "My technical foundation is built on " },
      { text: "SQL", strong: true },
      { text: ", " },
      { text: "Python", strong: true },
      { text: ", " },
      { text: "Power BI", strong: true },
      { text: ", " },
      { text: "dbt", strong: true },
      {
        text:
          ", and modern analytics engineering. I do not just report history; I design analytical systems that help teams forecast better, optimize decisions, and act with confidence.",
      },
    ],
    [
      {
        text:
          "I have delivered end-to-end analytics and research projects across ",
      },
      { text: "Finance", strong: true },
      { text: ", " },
      { text: "E-commerce", strong: true },
      { text: ", " },
      { text: "Business Intelligence", strong: true },
      { text: ", and " },
      { text: "Applied AI", strong: true },
      { text: ". As a " },
      { text: "Google Data Analytics certified", strong: true },
      { text: " candidate with a " },
      { text: "DataVision 2026 winning project", strong: true },
      {
        text:
          ", I focus on practical outcomes: identifying growth opportunities, improving operational efficiency, and translating data into decisions.",
      },
    ],
  ],
};

export const skills = {
  core: [
    {
      eyebrow: "Analytics Engineering",
      badge: "Data Analyst",
      title: "Business Intelligence",
      icon: "simple-icons:powerbi",
      color: "#F2C811",
      description:
        "Power BI dashboards, star schema design, DAX measures, KPI systems, and decision-ready business reporting.",
      items: [
        "Dashboard Design",
        "Data Modeling",
        "DAX Measures",
        "Enterprise Reports",
      ],
    },
    {
      eyebrow: "Data Engineering",
      badge: "Analytics Engineer",
      title: "Data Pipelines",
      icon: "mdi:database-cog",
      color: "#6F7DFF",
      description:
        "Data cleaning, warehouse layers, dbt transformations, SQL Server ETL, and repeatable analytics workflows.",
      items: [
        "ETL Pipelines",
        "Warehouse Layers",
        "dbt Models",
        "SQL Automation",
      ],
    },
  ],
  supporting: [
    {
      title: "Databases",
      icon: "mdi:database-outline",
      items: [
        {
          name: "SQL Server",
          icon: "simple-icons:microsoftsqlserver",
          color: "#CC2927",
        },
        {
          name: "PostgreSQL",
          icon: "simple-icons:postgresql",
          color: "#4169E1",
        },
        { name: "MySQL", icon: "simple-icons:mysql", color: "#4479A1" },
        { name: "MongoDB", icon: "simple-icons:mongodb", color: "#47A248" },
      ],
    },
    {
      title: "Analytics Engineering",
      icon: "mdi:layers-triple-outline",
      items: [
        { name: "dbt", icon: "simple-icons:dbt", color: "#FF694B" },
        { name: "T-SQL", icon: "mdi:code-tags", color: "#0078D4" },
        { name: "Data Modeling", icon: "mdi:table", color: "#6F7DFF" },
        { name: "Warehousing", icon: "mdi:warehouse", color: "#8B5CF6" },
      ],
    },
    {
      title: "Advanced Scripting",
      icon: "mdi:code-json",
      items: [
        { name: "PySpark", icon: "simple-icons:apachespark", color: "#E25A1C" },
        { name: "Python", icon: "simple-icons:python", color: "#3776AB" },
        { name: "Pandas", icon: "simple-icons:pandas", color: "#150458" },
        { name: "Notebooks", icon: "mdi:notebook-outline", color: "#F37626" },
      ],
    },
    {
      title: "Business Intelligence",
      icon: "mdi:chart-bar",
      items: [
        { name: "Power BI", icon: "simple-icons:powerbi", color: "#F2C811" },
        { name: "DAX", icon: "mdi:chart-line", color: "#F2C811" },
        { name: "Power Query", icon: "mdi:gauge", color: "#107C10" },
        { name: "Visualizations", icon: "mdi:chart-pie", color: "#5E5CE6" },
      ],
    },
    {
      title: "AI & ML",
      icon: "mdi:brain",
      items: [
        { name: "PyTorch", icon: "simple-icons:pytorch", color: "#EE4C2C" },
        {
          name: "TensorFlow",
          icon: "simple-icons:tensorflow",
          color: "#FF6F00",
        },
        { name: "OpenCV", icon: "simple-icons:opencv", color: "#5C3EE8" },
        {
          name: "HuggingFace",
          icon: "simple-icons:huggingface",
          color: "#FFD21E",
        },
      ],
    },
    {
      title: "Cloud & DevOps",
      icon: "mdi:cloud-outline",
      items: [
        { name: "AWS", icon: "simple-icons:amazonaws", color: "#FF9900" },
        { name: "Docker", icon: "simple-icons:docker", color: "#2496ED" },
        { name: "Git", icon: "simple-icons:git", color: "#F05032" },
        { name: "Linux", icon: "simple-icons:linux", color: "#FCC624" },
      ],
    },
  ],
};

export const experience = [
  {
    company: "Corporate Finance Governance Project",
    role: "Project Leader (Vietnam)",
    period: "Mar 2026 - Present",
    meta: "Cross-functional project with Hong Kong and Vietnam teams",
    description:
      "Led a cross-functional team across business, legal, and engineering to develop and implement a proprietary technology governance framework.",
    highlights: [
      "Acted as the strategic bridge between local operations and Hong Kong management.",
      "Designed engineering blueprints and supported a globally compliant legal framework.",
      "Coordinated multi-functional research directions and achieved full alignment with leadership vision.",
    ],
    tags: ["Leadership", "Governance", "Cross-functional", "Research"],
  },
  {
    company: "University of Economics Ho Chi Minh City",
    role: "Undergraduate Research Assistant",
    period: "Jan 2026 - Present",
    meta: "Advisor: PhD. Ho Thi Thanh Tuyen",
    description:
      "Supporting academic research work while building applied analytics and machine learning project experience.",
    highlights: [
      "Research focus connects applied data analysis, machine learning, and real-world business problem framing.",
      "Contributed to research and competition projects with structured experimentation and documentation.",
    ],
    tags: ["Research", "Machine Learning", "Data Analysis"],
  },
  {
    company: "UEH",
    role: "Undergraduate Research Assistant",
    period: "04/2025 - 12/2025",
    meta: "Advisor: PhD. Hoang Anh",
    description:
      "Conducted deep learning research on adaptive signature forgery detection, building a few-shot offline signature verification pipeline with Siamese and relation-based models for stronger cross-dataset generalization.",
    highlights: [
      "Worked on model design, experimentation, and evaluation for signature verification tasks.",
      "Applied PyTorch, YOLOv10, and OpenCV to support an end-to-end research workflow.",
    ],
    tags: ["Deep Learning", "PyTorch", "Computer Vision"],
  },
  {
    company: "UEH",
    role: "Undergraduate Research Assistant",
    period: "12/2024 - 08/2025",
    meta: "Advisor: PhD. Dang Ngoc Hoang Thanh",
    description:
      "Supported computer vision and image processing research for automated lymphocyte cell counting, focusing on detection, segmentation, and reliable counting workflows for microscopic images.",
    highlights: [
      "Developed practical experience in image analysis and computer vision research.",
      "Contributed to automated counting and image processing experiments with structured documentation.",
    ],
    tags: ["Computer Vision", "Image Processing", "Research"],
  },
];

export const education = {
  school: "University of Economics Ho Chi Minh City (UEH)",
  degree: "Bachelor's in Computer Science",
  period: "2023 - Mar 2027",
  location: "Ho Chi Minh City, Vietnam",
  gpa: "3.75 / 4.0",
  language: "IELTS 6.0",
  coursework: [
    "Database Systems",
    "Data Analytics",
    "Machine Learning",
    "Business Intelligence",
    "Statistics",
  ],
};

export const credentials = [
  {
    title: "Google Data Analytics Professional Certificate",
    issuer: "Coursera / Google",
    link:
      "https://www.coursera.org/account/accomplishments/specialization/certificate/UVCNMPK5690R",
    description:
      "Professional analytics foundation across data preparation, analysis, visualization, and business communication.",
  },
];

export const honorsAwards = [
  {
    title: "Winner of DataVision 2026",
    issuer: "Analytics competition",
    description:
      "Outperformed 250+ teams by architecting a comprehensive e-commerce analytics ecosystem.",
  },
  {
    title: "NCTD 2025 Accepted Research Paper",
    issuer: "International Scientific Conference",
    description:
      "Deep Learning-based Signature Forgery Detection for Personal Identity Authentication.",
  },
  {
    title: "BIT Genesis 2025 Runner-up",
    issuer: "Scientific Research Competition",
    description: "Won 2nd Prize in a scientific research competition.",
  },
  {
    title: "UEH Academic Scholarships",
    issuer: "UEH",
    description:
      "Awarded 4 academic scholarships for strong academic performance.",
  },
];

export const articles = [
  {
    title: "From Dashboard to Decision: Why ROI Modeling Matters",
    summary:
      "A portfolio note on turning e-commerce insights into budget scenarios, payback windows, and action gates.",
    tags: ["Analytics", "ROI", "Power BI"],
    readTime: "6 min read",
  },
];

export const projects = [
  {
    slug: "ecommerce-profitability-pipeline",
    category: "Analytics Engineering",
    title: "E-Commerce Profitability Pipeline",
    subtitle:
      "End-to-end e-commerce analytics ecosystem diagnosing margin compression despite rapid GMV growth.",
    description:
      "Processed multi-source e-commerce data, built Power BI dashboards, and added a Python + Excel ROI financial engine to convert operational insights into budget decisions.",
    repo:
      "https://github.com/Tommyhuy1705/E-Commerce_Data-Driven_Optimization_and_Profitability_Pipeline.git",
    image: asset("/project-assets/ecommerce-executive-overview.png"),
    gallery: [
      asset("/project-assets/ecommerce-executive-overview.png"),
      asset("/project-assets/ecommerce-forecast.png"),
    ],
    tags: ["Python", "Power BI", "Machine Learning", "ROI Modeling", "Pandas"],
    roles: ["Business Data Analyst"],
    metrics: [
      { value: "3.35M+", label: "Records Processed" },
      { value: "$10.83M", label: "GMV Analyzed" },
      { value: "$8.98M", label: "Frozen Capital" },
      { value: "112%+", label: "Base ROI" },
    ],
    challenge:
      "The business scaled quickly from 2019 to 2023, but profitability quality did not keep pace. The key question was why a 23x GMV growth story still produced shrinking net profit pressure and operational leakage.",
    pains: [
      "Status leakage reached roughly $4M, or 44.9% of GMV, across cancelled, processing, and returned orders.",
      "Inventory tied up $8.98M in frozen capital with a 36.1% sell-through rate.",
      "Customer retention was weak, with one-time buyers creating fragile customer economics.",
    ],
    solution:
      "Built a decision-support analytics pipeline combining cleaned fact/dimension tables, Power BI executive dashboards, forecasting benchmarks, RFM clustering, and a scenario-based ROI financial engine.",
    steps: [
      "Loaded seven raw CSV sources, validated schema quality, removed outliers, and engineered GMV, recognized revenue, gross profit, leakage, AOV, return rate, sell-through, and retention metrics.",
      "Modeled the dataset into a star schema with three fact tables and five dimension tables for performant Power BI analysis.",
      "Designed a five-page Power BI dashboard covering executive overview, customer funnel, product revenue, operations root causes, and forecast recommendations.",
      "Built a Phase 3 ROI engine testing inventory markdown, distribution-center rebalance, retention, checkout/OOS recovery, and return-cost reduction scenarios under a $500K budget.",
    ],
    architecture: [
      "Raw CSV sources",
      "Python/Pandas ETL",
      "Fact and dimension tables",
      "Power BI dashboard",
      "ROI financial engine",
    ],
    before: [
      "Growth narrative focused on GMV rather than conversion to recognized revenue.",
      "Leakage, inventory, and retention problems were spread across disconnected tables.",
      "Recommendations were not tied to budget, ROI, or payback logic.",
    ],
    after: [
      "Management-ready dashboard quantifies leakage, frozen capital, product mix, and customer economics.",
      "Base scenario projects $1.06M incremental gross profit, $562.6K net benefit, 112.52% ROI, and 5.65-month payback.",
      "Action matrix prioritizes inventory markdown guardrails, retention engine, status leakage control, checkout recovery, and product mix optimization.",
    ],
    technical: [
      [
        "Data volume",
        "3.35M+ records across transactions, inventory, behavioral events, and customer data",
      ],
      [
        "Model",
        "Star schema, aggregate tables, RFM K-Means, forecast baseline",
      ],
      [
        "Dashboard",
        "5 pages, 30+ visuals, Power BI import from processed CSV/Parquet",
      ],
      [
        "Decision engine",
        "Python + Excel scenario model with 13 internal consistency checks",
      ],
    ],
    outcomes: [
      "Identified $1.44M status leakage proxy from checkout friction for budget allocation.",
      "Quantified inventory as the largest short-term value pool with $8.98M frozen capital.",
      "Produced defendable action recommendations with caveats separating observed data, proxies, and assumptions.",
    ],
    acceptance: [
      "Clean fact/dimension outputs generated for BI consumption.",
      "Dashboard covers executive, customer, product, operations, and recommendation views.",
      "ROI model produces pessimistic, base, and optimistic scenarios with payback logic.",
    ],
  },
  {
    slug: "office-furniture-ecommerce-analysis",
    category: "Business Intelligence",
    title: "Office Furniture Sales & Operations Analytics",
    subtitle:
      "Power BI analysis of customer behavior, fulfillment risk, and product growth opportunities for office furniture e-commerce.",
    description:
      "Built a multi-page dashboard and data model from orders, customers, products, payment, and shipping tables to diagnose cancellation, retention, and product performance.",
    repo:
      "https://github.com/Tommyhuy1705/Office_Furniture_E-Commerce_Analysis.git",
    image: asset("/project-assets/office-overview.png"),
    gallery: [
      asset("/project-assets/office-overview.png"),
      asset("/project-assets/office-customer.png"),
      asset("/project-assets/office-product.png"),
    ],
    tags: ["Power BI", "DAX", "Data Modeling", "Python", "SQL"],
    roles: ["Business Data Analyst"],
    metrics: [
      { value: "$16.54M", label: "Revenue" },
      { value: "12,136", label: "Customers" },
      { value: "9,999", label: "Orders" },
      { value: "33%", label: "Cancel Rate" },
    ],
    challenge:
      "Despite strong revenue, the business faced a severe cancellation problem and weak customer retention, making sustainable growth uncertain.",
    pains: [
      "Cancellation rate reached 33%, more than 3x the target benchmark.",
      "68.3% of completed-purchase customers bought only once.",
      "Revenue concentration depended heavily on two SKUs, creating product portfolio risk.",
    ],
    solution:
      "Created an analytical Power BI model and dashboard suite that links operational cancellation patterns, customer segments, product performance, and action recommendations.",
    steps: [
      "Parsed and cleaned order data, including malformed order status variants and quantity-cost strings.",
      "Integrated five core entities: orders, customers, products, payments, and shipping.",
      "Built three dashboard pages: Overview, Customer, and Product.",
      "Converted seven insights into five prioritized actions with target KPIs.",
    ],
    architecture: [
      "CSV business tables",
      "Cleaning and standardization",
      "Power BI semantic model",
      "DAX KPI layer",
      "Operational dashboard",
    ],
    before: [
      "Cancellation, product, and customer problems were visible only as raw table symptoms.",
      "The team lacked a single view for revenue, orders, feedback, payment, shipping, and segment analysis.",
    ],
    after: [
      "Dashboard surfaces cancellation crisis, 1-time buyer issue, golden age segment, product concentration, and feedback risk.",
      "Recommendations target checkout/payment friction, RFM retention, CHR101 scaling, 61-80 customer segment, and feedback collection redesign.",
    ],
    technical: [
      [
        "Dataset",
        "9,999 orders, 12,136 customers, 13 SKUs, 5 payment methods, 5 shipping methods",
      ],
      ["Dashboard", "3 Power BI pages: Overview, Customer, Product"],
      [
        "KPIs",
        "Revenue, order status, AOV, product margin, cancellation rate, feedback score",
      ],
      ["Modeling", "Multi-table business model with DAX measures and filters"],
    ],
    outcomes: [
      "Found 33% cancellation rate distributed across product categories, pointing to system-level checkout or payment friction.",
      "Identified CHR101 as a scale-up candidate with 99.9% gross margin and 5.0/5 feedback.",
      "Highlighted 61-80 age group as a high-value segment generating $5.32M revenue.",
    ],
    acceptance: [
      "Dashboard supports date, gender, product, and age-group filtering.",
      "Insights link directly to prioritized actions and measurable KPIs.",
      "Power BI file and PDF report are available in the repository.",
    ],
  },
  {
    slug: "sql-data-warehouse",
    category: "Data Engineering",
    title: "End-to-End SQL Data Warehouse",
    subtitle:
      "SQL Server medallion architecture consolidating CRM and ERP sources into business-ready analytical tables.",
    description:
      "Designed a Bronze-Silver-Gold warehouse, implemented ETL scripts, documented data catalog and naming conventions, and modeled a Gold layer for analytics.",
    repo: "https://github.com/Tommyhuy1705/SQL_Data_Warehouse_Project.git",
    image: asset("/project-assets/warehouse-data-flow.png"),
    gallery: [
      asset("/project-assets/warehouse-data-flow.png"),
      asset("/project-assets/warehouse-data-model.png"),
      asset("/project-assets/warehouse-integration.png"),
    ],
    tags: ["SQL Server", "ETL", "Data Modeling", "Star Schema", "Medallion"],
    roles: ["Data Engineering"],
    metrics: [
      { value: "3", label: "Warehouse Layers" },
      { value: "2", label: "Source Systems" },
      { value: "Gold", label: "Analytics Layer" },
      { value: "SQL", label: "ETL Stack" },
    ],
    challenge:
      "Sales data was fragmented across CRM and ERP sources, making consistent customer, product, and sales reporting difficult.",
    pains: [
      "Raw source files needed standardization before they could support analytics.",
      "Stakeholders needed a documented model that both business and analytics teams could trust.",
      "Analytical queries required a clean fact and dimension layer rather than operational tables.",
    ],
    solution:
      "Implemented a SQL Server warehouse using medallion architecture: Bronze for raw ingestion, Silver for cleansing and normalization, and Gold for business-ready star schema reporting.",
    steps: [
      "Imported CRM and ERP CSV files into Bronze tables as raw source records.",
      "Applied Silver transformations to clean, standardize, and normalize source data.",
      "Created Gold dimension and fact tables for customer, product, and sales analytics.",
      "Documented data catalog, integration rules, naming conventions, and architecture diagrams.",
    ],
    architecture: [
      "ERP and CRM CSV",
      "Bronze raw layer",
      "Silver cleaned layer",
      "Gold star schema",
      "SQL analytics",
    ],
    before: [
      "CRM and ERP data lived as separate CSV extracts.",
      "No standardized warehouse layers or shared table naming rules.",
    ],
    after: [
      "Modern SQL warehouse supports customer behavior, product performance, and sales trend reporting.",
      "Gold layer contains documented dimension and fact tables for analytics use cases.",
    ],
    technical: [
      ["Database", "SQL Server"],
      ["Architecture", "Bronze, Silver, Gold medallion layers"],
      ["Gold layer", "dim_customers, dim_products, fact_sales"],
      [
        "Documentation",
        "Data catalog, naming conventions, data flow, data model diagrams",
      ],
    ],
    outcomes: [
      "Created a repeatable ETL structure from raw CSV sources to business-ready reporting tables.",
      "Improved analytical usability through fact/dimension modeling.",
      "Produced documentation that supports future BI/dashboard work.",
    ],
    acceptance: [
      "Raw ERP/CRM data is loaded into Bronze.",
      "Silver layer resolves quality and standardization issues.",
      "Gold layer is modeled for analytical queries and documented in a data catalog.",
    ],
  },
  {
    slug: "janus-bi-agent",
    category: "AI Analytics Platform",
    title: "Janus BI Multi-Agent Platform",
    subtitle:
      "AI web agent for natural-language revenue analytics, Text-to-SQL, dynamic dashboards, anomaly alerts, and audio briefings.",
    description:
      "Built a SaaS-ready business intelligence platform using Next.js, FastAPI, Supabase PostgreSQL, dbt, multi-provider LLM orchestration, SSE streaming, and AWS deployment.",
    repo: "https://github.com/Tommyhuy1705/AI_Web_Agent_For_Data_Analysis.git",
    visual: "agent",
    tags: ["FastAPI", "Next.js", "PostgreSQL", "dbt", "AWS", "LLM"],
    roles: ["Data Engineering"],
    metrics: [
      { value: "5", label: "Core Tasks" },
      { value: "SSE", label: "Realtime Stream" },
      { value: "dbt", label: "Data Mart" },
      { value: "AWS", label: "Deployment" },
    ],
    challenge:
      "Business users need fast insight generation, but traditional dashboards cannot answer ad-hoc questions, generate safe SQL, detect anomalies, or enrich answers with market context in one workflow.",
    pains: [
      "Manual SQL and dashboard workflows slow down time-to-insight.",
      "AI-generated SQL needs strict read-only controls before touching production-like data.",
      "Alerts, forecasting, market context, and reporting often live in disconnected tools.",
    ],
    solution:
      "Designed a multi-agent BI system where users ask natural-language questions, the backend routes intent, generates safe SQL, executes against Supabase, streams chart-ready results, and schedules automated BI workflows.",
    steps: [
      "Built Next.js frontend with chat workspace, chart canvas, dashboard page, and session history.",
      "Implemented FastAPI backend with chat streaming, SQL proxy, dashboard, prediction, market intelligence, audio, and history routes.",
      "Modeled a Zero Data Lake architecture with raw JSONB staging and dbt transformations into analytics_mart.",
      "Prepared Docker, GitHub Actions, AWS ECR, and EC2 deployment workflow.",
    ],
    architecture: [
      "Next.js UI",
      "FastAPI orchestration",
      "LLM Text-to-SQL",
      "Supabase PostgreSQL",
      "dbt analytics mart",
      "AWS deployment",
    ],
    before: [
      "Business questions required manual analyst intervention and separate tools for charts, forecasts, alerts, and reports.",
      "No single interface for safe Text-to-SQL plus dashboard generation.",
    ],
    after: [
      "SSE lifecycle streams start, status, SQL, data, chart, insight, and completion events to the browser.",
      "APScheduler jobs refresh dashboards, run dbt tests, send alarms, produce monthly reports, and crawl market intelligence.",
    ],
    technical: [
      [
        "Frontend",
        "Next.js 14, React 18, TypeScript, Tailwind, Zustand, ECharts, Recharts",
      ],
      ["Backend", "FastAPI, Pydantic v2, APScheduler, HTTPX, Uvicorn"],
      ["Data", "Supabase PostgreSQL, JSONB raw staging, dbt analytics_mart"],
      [
        "AI",
        "DashScope/Qwen primary, OpenAI fallback, Dify and Zilliz optional",
      ],
      ["DevOps", "Docker, Docker Compose, GitHub Actions, AWS ECR and EC2"],
    ],
    outcomes: [
      "Reduced business question flow into an interactive chat-to-chart experience.",
      "Added SQL guardrails that block modifying statements and recommend read-only credentials.",
      "Integrated forecasting, anomaly monitoring, market intelligence, and audio briefings into one platform architecture.",
    ],
    acceptance: [
      "Chat stream returns lifecycle events and chart configuration.",
      "Dashboard API aggregates revenue, product, segment, channel, and competitor datasets.",
      "dbt transforms raw data into analytics mart tables for serving.",
    ],
  },
  {
    slug: "olist-ecommerce-analytics",
    category: "Analytics Engineering",
    title: "Olist E-Commerce Analytics Platform",
    subtitle:
      "Brazilian marketplace analytics project combining EDA, star-schema warehousing, Iceberg Cube mining, bad-review prediction, FastAPI, and Streamlit.",
    description:
      "Built an end-to-end analytics stack for the Olist public dataset: preprocessing, feature engineering, PostgreSQL/SQL Server warehouse loading, OLAP cube analysis, ML classification, API service, and dashboard app.",
    repo: "https://github.com/Tommyhuy1705/Olist_E-Commerce_Analytics.git",
    visual: "warehouse",
    tags: [
      "PostgreSQL",
      "SQL Server",
      "FastAPI",
      "Streamlit",
      "Machine Learning",
    ],
    roles: ["Business Data Analyst", "Data Engineering"],
    metrics: [
      { value: "99K+", label: "Orders" },
      { value: "1M+", label: "Geo Rows" },
      { value: "9", label: "Raw CSVs" },
      { value: "7", label: "DWH Tables" },
    ],
    challenge:
      "The Olist marketplace dataset spans orders, customers, sellers, products, payments, reviews, freight, and geolocation. The analytical challenge was turning disconnected operational CSVs into business insight, warehouse tables, OLAP patterns, and a model that predicts poor customer reviews.",
    pains: [
      "Nine raw CSV sources use different grains and keys, making direct analysis fragile.",
      "Review quality depends on delivery timing, freight cost, payment behavior, order composition, and geography.",
      "Business insights, warehouse outputs, ML artifacts, and app/API layers needed one reproducible pipeline.",
    ],
    solution:
      "Created a reusable pipeline that processes the Olist data, builds star-schema outputs, loads a warehouse into PostgreSQL or SQL Server, runs Iceberg Cube analysis, trains a bad-review classifier, and serves results through FastAPI and Streamlit.",
    steps: [
      "Profiled the Olist dataset and mapped relationships across orders, order items, payments, reviews, products, sellers, customers, and geolocation.",
      "Implemented preprocessing and feature engineering for delivery days, delay days, freight ratio, order value, item count, seller count, category, payment behavior, and temporal features.",
      "Built a warehouse layer with fact_order_items plus date, customer, seller, product, payment, and order-status dimensions.",
      "Added scripts to run processed-data generation, warehouse loading, Iceberg Cube mining, and bad-review model training.",
      "Packaged analytics access through FastAPI endpoints and a Streamlit dashboard.",
    ],
    architecture: [
      "Olist CSV dataset",
      "Python preprocessing",
      "Star-schema warehouse",
      "Iceberg Cube + ML model",
      "FastAPI + Streamlit",
    ],
    before: [
      "Raw marketplace data was spread across nine files with different business grains.",
      "Review, delivery, payment, and geography patterns were hard to analyze together.",
      "No single pipeline connected EDA, DWH, OLAP, ML, and application delivery.",
    ],
    after: [
      "Warehouse-ready facts and dimensions support repeatable business analysis.",
      "Iceberg Cube summaries highlight revenue, delivery quality, satisfaction, and transaction-flow patterns.",
      "Bad-review classification turns operational features into a customer-experience risk signal.",
    ],
    technical: [
      [
        "Dataset",
        "99,441 orders, 112,650 order items, 103,886 payments, 99,224 reviews, and 1,000,163 geolocation rows",
      ],
      [
        "Warehouse",
        "PostgreSQL or SQL Server star schema with fact_order_items and six dimensions",
      ],
      [
        "ML target",
        "bad_review equals 1 for review_score <= 2 and 0 for review_score >= 4",
      ],
      ["Serving", "FastAPI service and Streamlit dashboard"],
    ],
    outcomes: [
      "Created a full-stack analytics project from raw Kaggle marketplace data to app-ready insights.",
      "Modeled delivery delay, freight, payment, item, seller, geography, and calendar signals for review-risk prediction.",
      "Separated reusable pipeline scripts from notebooks so the project can be rerun end to end.",
    ],
    acceptance: [
      "Processed data and star-schema CSVs can be regenerated by script.",
      "Warehouse loader supports PostgreSQL and SQL Server configuration.",
      "FastAPI and Streamlit layers expose the analytical outputs for interactive use.",
    ],
  },
  {
    slug: "saas-customer-manager",
    category: "Cloud Data Application",
    title: "SaaS Customer Manager",
    subtitle:
      "Multi-tenant customer management SaaS with isolated tenant data, automated SMS/email messaging, analytics dashboard, and AWS deployment.",
    description:
      "Implemented a production-style SaaS stack using React, Express, Prisma, MySQL, JWT authentication, SendGrid, SpeedSMS, Docker Compose, and AWS infrastructure planning.",
    repo: "https://github.com/Tommyhuy1705/SaaS-customer-manager.git",
    visual: "saas",
    tags: ["React", "Express", "Prisma", "MySQL", "AWS"],
    roles: ["Data Engineering"],
    metrics: [
      { value: "2-step", label: "Tenant Auth" },
      { value: "MySQL", label: "RDS Layer" },
      { value: "SMS", label: "SpeedSMS" },
      { value: "Email", label: "SendGrid" },
    ],
    challenge:
      "Small organizations need a customer communication platform that can separate tenant data, manage contacts, send outbound campaigns, and monitor delivery performance without mixing records across organizations.",
    pains: [
      "Multi-tenant systems need strict data isolation at middleware and query levels.",
      "SMS and email delivery need history tracking, failure visibility, and webhook-ready status updates.",
      "A SaaS app requires backend, frontend, database, local Docker setup, and cloud deployment design to work together.",
    ],
    solution:
      "Built a full-stack SaaS customer manager with tenant-aware JWT authentication, customer CRUD, message history, SendGrid email, SpeedSMS integration, dashboard metrics, Prisma ORM, Docker Compose, and AWS deployment documentation.",
    steps: [
      "Designed backend modules for controllers, services, middleware, validators, Prisma schema, and tests.",
      "Implemented a two-step authentication flow: login first, then tenant selection for scoped access.",
      "Created customer management and message-history workflows with tenant isolation.",
      "Built React + Vite frontend pages using Ant Design, React Router, Axios, and Recharts.",
      "Documented production deployment using ECS Fargate, RDS MySQL, S3, CloudFront, ALB, ACM, and CloudWatch.",
    ],
    architecture: [
      "React + Vite UI",
      "Express API",
      "JWT tenant middleware",
      "Prisma + MySQL",
      "SendGrid + SpeedSMS",
      "AWS deployment",
    ],
    before: [
      "Customer records and communications had no unified SaaS interface.",
      "Tenant separation, messaging, and dashboard tracking were independent concerns.",
    ],
    after: [
      "Organizations can manage customers independently with isolated tenant context.",
      "SMS/email status and dashboard metrics provide operational visibility.",
      "Docker and AWS documentation make the system reproducible locally and deployable in cloud infrastructure.",
    ],
    technical: [
      [
        "Backend",
        "Node.js 20, Express, Prisma singleton pattern, MySQL 8.0, JWT, Joi validation",
      ],
      ["Frontend", "React 18, Vite, Ant Design, Axios, React Router, Recharts"],
      [
        "Messaging",
        "SendGrid email SDK, SpeedSMS API, webhook tracking design",
      ],
      [
        "Infrastructure",
        "Docker Compose, ECS Fargate, S3, CloudFront, RDS MySQL, ALB, ACM, CloudWatch",
      ],
    ],
    outcomes: [
      "Delivered a multi-tenant SaaS architecture with real-world data isolation requirements.",
      "Connected transactional customer data with communication delivery metrics.",
      "Prepared a cloud deployment path that separates frontend hosting, backend containers, and managed database.",
    ],
    acceptance: [
      "Local stack can run through Docker Compose with MySQL, backend, and frontend services.",
      "Authentication scopes users to a selected tenant before data access.",
      "Dashboard and message history expose success/failure outcomes for communications.",
    ],
  },
  {
    slug: "lymphocyte-cell-counting",
    category: "Computer Vision Research",
    title: "Automated Lymphocyte Cell Counting",
    subtitle:
      "Benchmark of YOLOv8 detection and U-Net segmentation for automated lymphocyte counting in biomedical images.",
    description:
      "Compared detection-based and segmentation-based deep learning approaches for cell counting, with augmentation, evaluation notebooks, pretrained model links, and a Streamlit demo app.",
    repo:
      "https://github.com/Tommyhuy1705/Automatic-Lymphocyte-Cell-Counting-a-perspective-approach-from-image-segmentation-and-deep-learning.git",
    visual: "cell",
    tags: ["YOLOv8", "U-Net", "OpenCV", "Streamlit", "Deep Learning"],
    roles: ["Scientific Research"],
    metrics: [
      { value: "0.92", label: "YOLO R2" },
      { value: "43.15", label: "YOLO MAE" },
      { value: "14.19", label: "YOLO MAPE" },
      { value: "31.58", label: "U-Net MAPE" },
    ],
    challenge:
      "Manual lymphocyte counting is slow and error-prone, while biomedical images require reliable localization or segmentation before counts can be trusted for research and diagnostic support.",
    pains: [
      "Manual microscope counting does not scale and introduces observer variability.",
      "Detection and segmentation approaches behave differently under image augmentation and noisy morphology.",
      "Counting quality needs regression-style metrics, not only visual inspection.",
    ],
    solution:
      "Benchmarked YOLOv8 object detection against U-Net segmentation on an augmented lymphocyte dataset, then wrapped inference in a Streamlit app where users upload microscopy images and compare predicted boxes, masks, and counts.",
    steps: [
      "Built augmentation workflow with rotation, flipping, shifting, scaling, brightness changes, and Gaussian noise.",
      "Trained YOLOv8 for bounding-box localization and U-Net for pixel-level segmentation masks.",
      "Evaluated both approaches with RMSE, MAE, MAPE, R2, and dispersion statistics.",
      "Prepared a Streamlit application for real-time upload, visualization, and automated count output.",
    ],
    architecture: [
      "Microscopy image",
      "Augmentation pipeline",
      "YOLOv8 / U-Net",
      "Metric evaluation",
      "Streamlit counting app",
    ],
    before: [
      "Cell counting depended on slow manual review.",
      "The project lacked evidence for choosing detection versus segmentation.",
    ],
    after: [
      "YOLOv8 achieved stronger counting performance than U-Net on the reported benchmark.",
      "The app visualizes model predictions and returns automated lymphocyte counts from uploaded images.",
    ],
    technical: [
      ["Detection", "YOLOv8 bounding-box model"],
      ["Segmentation", "U-Net binary mask model"],
      ["Evaluation", "YOLOv8 RMSE 71.34, MAE 43.15, MAPE 14.19, R2 0.92"],
      [
        "Deployment",
        "Streamlit app with pretrained model links on Hugging Face",
      ],
    ],
    outcomes: [
      "Showed YOLOv8 as the stronger approach for the benchmark with lower error and higher R2.",
      "Created reproducible notebooks for augmentation, algorithm experiments, deep learning, and evaluation.",
      "Delivered a working app for biomedical image upload and model comparison.",
    ],
    acceptance: [
      "Users can upload cell images and test both YOLOv8 and U-Net predictions.",
      "Predictions are visualized with bounding boxes or segmentation masks.",
      "Evaluation reports RMSE, MAE, MAPE, R2, and dispersion statistics.",
    ],
  },
  {
    slug: "real-estate-information-extraction",
    category: "NLP Research",
    title: "Real Estate Information Extraction",
    subtitle:
      "Comparative ML and deep-learning study for Vietnamese real-estate NER and relation extraction.",
    description:
      "Built an end-to-end IE research pipeline for Vietnamese property listings, comparing CRF/SVM/MaxEnt/RF baselines with PhoBERT-based deep learning for entity and relation extraction.",
    repo:
      "https://github.com/Tommyhuy1705/Comparative_ML_Deep_Learning_Approaches_for_Information_Extraction_in_Real_Estate.git",
    visual: "nlp",
    tags: ["PhoBERT", "NER", "Relation Extraction", "CRF", "SVM"],
    roles: ["Scientific Research"],
    metrics: [
      { value: "2", label: "IE Tasks" },
      { value: "ML", label: "Baselines" },
      { value: "DL", label: "PhoBERT" },
      { value: "NER+RE", label: "Pipeline" },
    ],
    challenge:
      "Vietnamese real-estate listings contain noisy text, abbreviations, inconsistent price/area formats, and implicit relationships between entities such as property, location, price, and area.",
    pains: [
      "Raw property descriptions are messy and domain-specific.",
      "Entity extraction alone is not enough; the system must also link entities through relations.",
      "Class imbalance makes relation extraction difficult without sampling and weighting strategies.",
    ],
    solution:
      "Designed a comparative research pipeline that prepares raw text into labeled model inputs, trains ML and DL approaches for NER and RE, applies PhoBERT embeddings/fine-tuning, and exposes a Streamlit UI for end-to-end extraction testing.",
    steps: [
      "Organized data into raw, intermediate JSON, labeled primary data, and model-input stages.",
      "Built NER experiments with CRF, SVM, MaxEnt, and PhoBERT token classification.",
      "Built RE experiments with SVM, Logistic Regression, Random Forest using PhoBERT vectors, entity markers, PCA, hybrid sampling, and class weights.",
      "Benchmarked ML and DL notebooks and prepared a demo UI for structured extraction from listing text.",
    ],
    architecture: [
      "Raw listings",
      "Data preparation",
      "NER models",
      "Relation extraction",
      "Structured property info",
    ],
    before: [
      "Real-estate listing information was locked inside unstructured Vietnamese text.",
      "Traditional parsing could not handle abbreviations, spelling issues, and varied formatting reliably.",
    ],
    after: [
      "The IE pipeline identifies entities such as location, price, area, and property type.",
      "Relation extraction links entity pairs into structured facts such as property price or property location.",
    ],
    technical: [
      ["NER ML", "CRF, SVM, MaxEnt with handcrafted features"],
      ["NER DL", "PhoBERT-base fine-tuned for token classification"],
      [
        "RE ML",
        "SVM, Logistic Regression, Random Forest with PhoBERT vectors and entity markers",
      ],
      [
        "Optimization",
        "PCA, hybrid sampling, SMOTE-style balancing, class weights",
      ],
    ],
    outcomes: [
      "Created a full research workflow from annotation-oriented data management to model comparison.",
      "Compared lightweight ML methods against contextual deep-learning representations.",
      "Handled Vietnamese real-estate text characteristics such as abbreviations, noisy spelling, and irregular numeric formats.",
    ],
    acceptance: [
      "Prepared data can be generated through scripts before model training.",
      "NER and RE experiments are reproducible through notebooks.",
      "Demo UI can test the complete raw-text to structured-information pipeline.",
    ],
  },
  {
    slug: "signature-forgery-verification",
    category: "Machine Learning Research",
    title: "Adaptive Signature Forgery Detection",
    subtitle:
      "Few-shot offline signature verification using YOLOv10 preprocessing, Triplet Siamese networks, and Relation Networks.",
    description:
      "Research system for personal identity authentication across heterogeneous signature datasets, with meta-learning evaluation on CEDAR and BHSig-style data.",
    repo:
      "https://github.com/Tommyhuy1705/Adaptive-Meta-Learning-Framework-for-Few-Shot-Offline-Signature-Verification-Using-Relation-Networks.git",
    visual: "signature",
    tags: ["PyTorch", "YOLOv10", "OpenCV", "Few-shot Learning", "AUC"],
    roles: ["Scientific Research"],
    metrics: [
      { value: "0.9467", label: "Avg AUC" },
      { value: "8.18%", label: "Avg EER" },
      { value: "5", label: "K-Folds" },
      { value: "260", label: "BHSig Users" },
    ],
    challenge:
      "Offline signature verification is difficult when only a few samples are available per identity and datasets differ in language, writing style, scan quality, and forgery behavior.",
    pains: [
      "Models overfit writer-specific patterns and struggle to generalize across CEDAR and BHSig-like datasets.",
      "Signature regions need reliable extraction before metric-learning models can compare samples.",
      "Evaluation must track EER, AUC, F1, precision, and recall rather than simple accuracy alone.",
    ],
    solution:
      "Built an adaptive meta-learning pipeline combining YOLOv10 signature localization, Triplet Siamese representation learning, Relation Networks, and k-fold few-shot evaluation.",
    steps: [
      "Prepared signature detection data from bank-check segmentation masks and trained YOLOv10 to crop high-confidence signature regions.",
      "Consolidated BHSig Hindi and Bengali users into disjoint pretraining and meta-learning splits.",
      "Generated triplets and trained a Triplet Siamese Similarity Network with metric-learning loss.",
      "Ran k-fold meta-training and evaluated EER, accuracy, AUC, F1, precision, and recall.",
    ],
    architecture: [
      "Signature image",
      "YOLOv10 crop",
      "Triplet Siamese encoder",
      "Relation Network",
      "Few-shot verification score",
    ],
    before: [
      "Raw bank-check or signature scans contain noise and variable layout.",
      "Classic classifiers require more writer-specific samples than realistic verification settings provide.",
    ],
    after: [
      "Few-shot pipeline evaluates writer pairs with cross-fold metrics.",
      "Best fold results reached 0.00% EER and 1.0000 AUC; average meta-training summary reported 8.18% EER and 0.9467 AUC.",
    ],
    technical: [
      ["Detection", "YOLOv10 on bank-check signature segmentation dataset"],
      [
        "Representation",
        "Triplet Siamese Similarity Network with triplet loss",
      ],
      ["Meta-learning", "Relation Network few-shot verification episodes"],
      ["Evaluation", "EER, ROC-AUC, F1, accuracy, precision, recall"],
    ],
    outcomes: [
      "Research paper accepted for NCTD 2025 International Scientific Conference.",
      "Built reproducible notebooks for preprocessing, YOLO training, baseline metric selection, pretraining, and meta-training.",
      "Validated the approach across k-fold experiments with detailed metric tracking.",
    ],
    acceptance: [
      "Signature crops are produced from high-confidence YOLO detections.",
      "Training uses disjoint pretraining and meta-learning user splits.",
      "Evaluation reports EER and AUC across folds.",
    ],
  },
];
